<template>
  <div class="tabbar-wrapper">
    <div class="tabbar-bg">
      <img src="@/assets/img/tabbar/Union.png" alt="bg" />
    </div>
    <div class="tabbar-content">
      <div 
        class="tab-item"
        :class="{active: $route.name === 'home'}"
        @click="to('/')"
      >
        <img v-if="$route.name === 'home'" src="@/assets/img/tabbar/shouye-active.png" alt="home" />
        <img v-else src="@/assets/img/tabbar/shouye.png" alt="home" />
        <span>{{ $t('tab.home') }}</span>
      </div>
      <div class="tab-item center" :class="{active: $route.name === 'prediction'}" @click="toPrediction">
        <div class="center-icon">
          <img src="@/assets/img/tabbar/monijin.png" alt="sim" />
        </div>
        <span>{{ $t('tab.sim') }}</span>
      </div>
      <div 
        class="tab-item"
        :class="{active: $route.name === 'my'}"
        @click="to('/my')"
      >
        <img v-if="$route.name === 'my'" src="@/assets/img/tabbar/wode-active.png" alt="me" />
        <img v-else src="@/assets/img/tabbar/wode.png" alt="me" />
        <span>{{ $t('tab.my') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabbar',
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  methods: {
    toPrediction() {
      if(this.userInfo && this.userInfo.address) {
        this.$router.replace('/prediction')
      } 
    },
    to(url){
      if(this.userInfo && this.userInfo.address) {
        this.$router.replace(url)
      } 
    },
  }
};
</script>

<style scoped lang="scss">
.tabbar-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 88px; /* Based on background image height */
  z-index: 100;
  display: flex;
  justify-content: center;
  pointer-events: none; /* Allow clicks to pass through wrapper to content */
  
  .tabbar-bg {
    position: absolute;
    bottom: 0;
    width: 348px;
    height: 86px;
    z-index: 1;
    pointer-events: auto;
    background-color: #000;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  
  .tabbar-content {
    position: absolute;
    bottom: 0;
    width: 343px;
    height: 60px; /* Content area height, roughly */
    z-index: 2;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 10px; /* Adjust vertical alignment */
    pointer-events: auto;
    
    .tab-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #666;
      font-size: 10px;
      cursor: pointer;

      img {
        width: 24px;
        height: 24px;
        margin-bottom: 4px;
      }

      &.active {
        color: #FF5621;
      }

      &.center {
        position: relative;
        top: -10px; /* Lift up to match the bump in background */
        
        .center-icon {
          /* background-color: #1a1a1a; Removed manual background circle as it might be part of design or handled differently */
          /* If the image has a hole or specific design for the center button, we just place the icon */
          /* Assuming the Union.png has the shape, we just position the icon */
          
          img {
              width: 44px; /* Slightly larger */
              height: 44px;
              margin-bottom: 0;
          }
        }
        
        span {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
